<template>
  <div>
    <div class="box">
      <blue-title class="style">登记证书</blue-title>
      <div>
        <div class="info" style="height: 70px">
          <span class="marRight">登记证书照片</span
          ><span
            ><el-image
              :src="subjectData.certCopy"
              alt=""
              style="width: 58px; height: 58px"
            ></el-image
          ></span>
        </div>
        <div class="info"><span class="marRight">登记证书类型</span><span>{{subjectData.certType}}</span></div>
        <div class="info"><span class="marRight">商户名称</span><span>{{subjectData.businessLicenseInfoMerchantName}}</span></div>
        <div class="info"><span class="marRight">注册地址</span><span>{{subjectData.companyAddress}}</span></div>

        <div class="info"><span class="marRight">法人姓名</span><span>{{subjectData.businessLicenseInfoLegalPerson}}</span></div>
        <div class="info"><span class="marRight">证件有效期类型</span><span>-----</span></div>
        <div class="info"><span class="marRight">有效期限开始日期</span><span>{{subjectData.periodBegin}}</span></div>
        <div class="info"><span class="marRight">有效期限结束日期</span><span>{{subjectData.periodEnd}}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    subjectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },

  watch: {},

  methods: {},
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  box-sizing: border-box;
  height: 100%;

  .info {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333;
    font-weight: 500;
    height: 42px;
    border-bottom: 1px solid #e5e5e5;
  }
  .style {
    font-size: 12px;
    color: #333;
    font-weight: 500;
    margin: 11px 0 18px 0;
  }
  .marRight {
    width: 100px;
    margin-right: 38px;
  }
}
</style>
